export default {
  next: 'Next',
  solution: 'Show solution',
  chooseSelectBox: 'Please choose'
}
